export const en = {
  brand: {
    name: "Green Horizon Project",
    short: "GHP",
    tagline: "French non-profit (loi 1901) — Sussac, Haute-Vienne",
    message: "The future of climate research starts with the questions we ask today.",
    messageNote: "A brand orientation — not a scientific quotation."
  },
  nav: {
    association: "The association",
    research: "Research",
    join: "Get involved",
    mission: "Our mission",
    histoire: "Our story",
    transparence: "Transparency",
    recherche: "Scientific research",
    centre: "The future Centre",
    programme: "Research programme",
    roadmap: "Roadmap",
    scientifiques: "Scientific network",
    partenariats: "Partnerships",
    soutenir: "Support research",
    actualites: "News",
    ressources: "Resources",
    contact: "Contact",
    participate: "Get involved",
    menu: "Menu",
    close: "Close"
  },
  status: {
    done: "Completed — documented",
    progress: "In progress",
    prep: "In preparation",
    vision: "Future vision"
  },
  forms: {
    name: "Full name",
    email: "Email address",
    organization: "Organisation (optional)",
    subject: "Subject",
    message: "Your message",
    profile: "Your profile",
    domain: "Area of expertise",
    orgType: "Type of organisation",
    supportType: "Type of support considered",
    proposalTitle: "Proposal title",
    consent: "I agree that my data will be processed in the context of my request, in accordance with the privacy policy.",
    sending: "Sending…",
    success: "Your message has been sent. We will get back to you shortly.",
    error: "Something went wrong. Please try again.",
    newsletterSuccess: "Subscription confirmed. Thank you for your interest.",
    requiredNote: "All marked fields are required.",
    fonction: "Position (optional)",
    pays: "Country",
    site: "Professional profile / website (optional)",
    contribution: "Type of contribution considered",
    contributionOptions: ["Scientific research", "Supervision / expertise", "Engineering and technical development", "Field missions and data", "Institutional partnership", "Scientific advice", "Other"],
    profileOptions: ["Researcher", "Lecturer-researcher", "Engineer", "Professor", "Technician", "Student / Early-career researcher", "Climate specialist", "Environment or energy professional", "Inventor", "Other"],
    orgTypeOptions: ["University", "Laboratory", "Research organisation", "Engineering school", "Consulting firm", "Technology company", "Local authority", "Public institution", "Environmental organisation", "International organisation", "Foundation / Patron", "Other"],
    supportTypeOptions: ["Membership", "Donation", "Corporate patronage", "Private partnership", "Public grant", "Call for projects", "Framework agreement", "Material or technological support", "Expertise or skills", "Other"]
  },
  footer: {
    baseline: "A French non-profit dedicated to understanding climate change and researching lasting solutions.",
    explore: "Explore",
    researchCol: "Research",
    legal: "Information",
    newsletterTitle: "Follow the building of the project",
    newsletterText: "Receive the key milestones in the preparation of the future research Centre.",
    newsletterPlaceholder: "Your email address",
    newsletterButton: "Subscribe",
    legalLine: "Non-profit organisation under the French law of 1 July 1901 — Registered office: 99 Route de la Croisille-sur-Briance, 87130 Sussac, France",
    mentions: "Legal notice",
    privacy: "Privacy policy",
    rights: "All rights reserved.",
    socialSoon: "Our social media channels will launch soon.",
    socialTitle: "Social media — launching soon"
  },
  home: {
    metaTitle: "Green Horizon Project — Preparing tomorrow's climate research",
    metaDesc: "Green Horizon Project (GHP) is a French non-profit based in Sussac (Haute-Vienne). Its structuring project: preparing the creation of a research Centre dedicated to the global climate.",
    heroOverline: "French non-profit (loi 1901) — Sussac, Haute-Vienne, France",
    heroLines: ["Preparing scientific", "research to meet", "the climate challenges", "of tomorrow."],
    heroText: "Green Horizon Project is a French non-profit dedicated to fighting the effects of global climate change, protecting the environment and supporting the energy transition. Our ambition: to progressively build a scientific and technical ecosystem able to contribute to the understanding of climate transformations and to the search for lasting solutions. Our structuring project: preparing the creation of a research Centre dedicated to the climate.",
    ctaVision: "Discover our vision",
    ctaJoin: "Join the project",
    marquee: ["Understand the climate", "Anticipate transformations", "Research lasting solutions", "Science", "Data", "Territory", "Innovation", "Cooperation"],
    visionOverline: "Our vision",
    visionTitle: "A scientific approach, serving the climate and local territories",
    pillars: [
      { num: "01", title: "Understand the climate", text: "Gathering and producing the knowledge needed to understand climate transformations, at every scale." },
      { num: "02", title: "Anticipate transformations", text: "Identifying possible trajectories and the data to produce in order to inform tomorrow's decisions." },
      { num: "03", title: "Research lasting solutions", text: "Turning scientific knowledge into concrete, testable solutions that serve local territories." }
    ],
    bridgeOverline: "A bridge between worlds",
    bridgeTitle: "Connecting knowledge, tools and actors",
    bridgeItems: ["Scientific research", "Engineering", "Innovation", "Field observation", "Energy transition", "Environmental protection", "Institutional cooperation", "Knowledge transfer"],
    centreOverline: "Structuring project — in preparation",
    centreTitle: "The future Global Climate Research Centre",
    centreText: "The research Centre does not exist yet: it is the ambition that structures everything Green Horizon Project does. Preparing its creation means, starting today, bringing together skills, defining programmes and building the partnerships that will make it possible.",
    centreCta: "Discover the project",
    timelineOverline: "Milestones",
    timelineTitle: "A path we stand by",
    timelineItems: [
      { date: "31 October 2022", label: "Statutory creation of the association in Limoges" },
      { date: "17 April 2025", label: "Extraordinary general assembly: a new momentum" },
      { date: "Tomorrow", label: "The Global Climate Research Centre" }
    ],
    timelineCta: "Our story",
    manifestoOverline: "Our conviction",
    ctaTitle: "Building this ambition takes alliances.",
    ctaText: "Researchers, engineers, institutions, companies, patrons: every skill matters in preparing the future research Centre.",
    cta1: "Join the scientific network",
    cta2: "Propose a partnership",
    cta3: "Support GHP"
  },
  mission: {
    metaTitle: "Our mission — Green Horizon Project",
    metaDesc: "Understand the climate, anticipate transformations, research lasting solutions: the mission of the Green Horizon Project association.",
    overline: "Our mission",
    titleLines: ["Understand. Anticipate.", "Research."],
    intro: "Green Horizon Project was born of a conviction: answers to climate challenges will come from scientific research, technological innovation and cooperation between actors. The association works to fight the effects of global climate change, to promote and protect the environment, and to support the energy transition.",
    positionOverline: "Positioning",
    positionTitle: "Five dimensions, one approach",
    positions: [
      { title: "Scientific", text: "Methodological rigour as the foundation: precise questions, verifiable data, documented results." },
      { title: "Environmental", text: "Environmental protection as the horizon of every piece of work envisaged." },
      { title: "Technological", text: "Engineering and innovation as levers for measurement, modelling and action." },
      { title: "Territorial", text: "Rooted in a rural French territory, open to global climate challenges." },
      { title: "International", text: "The climate knows no borders: neither does scientific cooperation." }
    ],
    principlesOverline: "Our communication principles",
    principlesTitle: "Talking about what truly matters",
    principles: [
      "What knowledge are we missing?",
      "What data must we produce?",
      "Which solutions can we test?",
      "How do we turn research into impact?"
    ],
    principlesNote: "Our communication aims to be credible, scientific, transparent, ambitious, sober, international and solution-oriented."
  },
  histoire: {
    metaTitle: "Our story — Green Horizon Project",
    metaDesc: "From its statutory creation in Limoges on 31 October 2022 to the new momentum launched in 2025: the story of Green Horizon Project.",
    overline: "Our story",
    titleLines: ["One association,", "one trajectory."],
    intro: "The history of Green Horizon Project is documented by two primary sources: the founding statutes, adopted on 31 October 2022 in Limoges, and the minutes of the extraordinary general assembly of 17 April 2025. Nothing else is asserted without a source.",
    items: [
      {
        date: "31 October 2022",
        title: "Statutory creation — Limoges",
        text: "Creation of Green Horizon Project and adoption of its founding statutes. These define the association's climate, environmental and energy purpose, as well as the ambition to seek the means necessary to create a future Global Climate Research Centre.",
        status: "done"
      },
      {
        date: "2023 – 2024",
        title: "Early years of operation",
        text: "The association went through its first years of operation, including in 2024 operating difficulties notably linked to the treasurer's geographical distance. This period is presented soberly: the activities of these years are not, at this stage, documented publicly in detail.",
        status: "done"
      },
      {
        date: "17 April 2025",
        title: "Extraordinary general assembly — Limoges",
        text: "This assembly marks a new momentum and a reorganisation of governance. Elected: Mr Cyril Mulumba Mukendi, President, and Ms Marie-Odile Isabelle Basthier, Secretary; the treasurer's seat remains vacant until further notice. Mr Marcel Samuel Kadima Kalonji remains a founding member outside the Board, and Ms Émilie Millet remains the field activities coordinator.",
        status: "done"
      },
      {
        date: "2026",
        title: "Structuring and reflection",
        text: "A new period of structuring and reflection on the future of Green Horizon Project: digital presence, scientific watch, a network of skills and the search for relevant collaborations.",
        status: "progress"
      },
      {
        date: "In time",
        title: "Towards the future Centre",
        text: "Progressive continuation of the project and, once the conditions are met, development of scientific work followed by the creation of the future Global Climate Research Centre. No date is set.",
        status: "vision"
      }
    ],
    legendTitle: "How to read this site",
    legendText: "What has been achieved is documented. What is in preparation is identified as such. What belongs to the future vision is presented as an ambition."
  },
  recherche: {
    metaTitle: "Scientific research — Green Horizon Project",
    metaDesc: "Green Horizon Project's scientific approach: ask the right questions, produce the data, test the solutions.",
    overline: "Scientific research",
    titleLines: ["Tomorrow's research begins", "with today's questions."],
    intro: "Green Horizon Project claims no published research work to date. This page presents an orientation: how the association intends to approach climate science once its research ecosystem is in place.",
    blocksOverline: "Our approach",
    blocksTitle: "Four questions that structure our work",
    blocks: [
      { num: "01", title: "What do we want to understand?", text: "The evolution of climate phenomena, their effects on territories, the dynamics of the energy transition: defining precise research objects is our first task." },
      { num: "02", title: "What data must we produce?", text: "No credible research without reliable data. Observation, measurement, cross-referencing open sources: data is the raw material of the future Centre." },
      { num: "03", title: "Which solutions can we test?", text: "Technological, organisational, territorial: identifying concrete answers to the effects of climate change and putting them to the test of reality." },
      { num: "04", title: "How do we create impact?", text: "Turning scientific knowledge into solutions that territories, companies and institutions can actually use." }
    ],
    honestyTitle: "Our commitment to honesty",
    honestyText: "This site systematically distinguishes between what has been achieved, what is in preparation and what belongs to the future vision. No publication, no result, no partnership is presented without a verifiable source.",
    cta: "Explore the research programme"
  },
  centre: {
    metaTitle: "The future research Centre — Green Horizon Project",
    metaDesc: "Building today the scientific infrastructure of tomorrow: the Global Climate Research Centre envisioned by Green Horizon Project.",
    overline: "Structuring project — in preparation",
    titleLines: ["The future Global", "Climate Research Centre"],
    subtitle: "Building today the scientific infrastructure of tomorrow.",
    disclaimer: "The research Centre does not exist yet. This page presents a structuring ambition of the association: its orientations, its envisioned architecture and the stages of its preparation.",
    vocationOverline: "Purpose of the future Centre",
    vocationTitle: "What the Centre will aim to become",
    vocations: [
      "Conduct or coordinate climate research work",
      "Bring together researchers, engineers, technicians and experts",
      "Develop lasting scientific collaborations",
      "Study the effects of climate change",
      "Identify lasting, testable solutions",
      "Turn scientific results into concrete solutions",
      "Organise field missions and studies",
      "Collaborate with institutions, universities, companies and specialised bodies"
    ],
    axesOverline: "What its construction will require",
    axesTitle: "Conditions to be met, progressively",
    axesNote: "The Centre's future scientific organisation remains intentionally open: the definitive research axes will be determined from the work actually carried out.",
    axes: [
      { num: "01", title: "Skills", text: "Progressively gathering the scientific, technical and human knowledge required." },
      { num: "02", title: "Researchers and experts", text: "Building a network of skills committed to the project." },
      { num: "03", title: "Collaborations", text: "Working with institutions, universities, companies and organisations." },
      { num: "04", title: "Infrastructures", text: "Preparing the material and organisational means of research." },
      { num: "05", title: "Financial resources", text: "Seeking public and private funding, patronage and grants." },
      { num: "06", title: "Partnerships", text: "Building lasting alliances — local, national and international." },
      { num: "07", title: "Prior scientific work", text: "First engaging in research and watch activities that will establish the Centre's legitimacy." }
    ],
    ctaTitle: "This Centre will be built with those who believe in useful science.",
    cta1: "Join the scientific network",
    cta2: "See the roadmap"
  },
  programme: {
    metaTitle: "Research programme — Green Horizon Project",
    metaDesc: "The future research of Green Horizon Project: envisioned domains, research questions, methodologies and sought collaborations.",
    overline: "Research programme",
    titleLines: ["The future research", "of Green Horizon Project"],
    intro: "This page is an evolving platform: it will grow with the preparatory work of the future Centre. Each domain below is a structured line of reflection — problem statement, questions, envisioned methodology, required data, sought collaborations, expected outcomes. No scientific results are published to date. The definitive research axes will be refined later, based on the scientific work actually undertaken.",
    labels: {
      problematique: "Problem statement",
      questions: "Research questions",
      methodologie: "Envisioned methodology",
      donnees: "Required data",
      collaborations: "Sought collaborations",
      resultats: "Expected outcomes"
    },
    domains: [
      {
        title: "Understanding climate dynamics",
        problematique: "How can we better understand the evolution of climate phenomena at local and global scales?",
        questions: ["Which indicators should be tracked to qualify local climate transformations?", "How can global climate data and field observations be articulated?", "Which witness territories could track changes over time?"],
        methodologie: "Scientific literature review, collection and cross-referencing of open data, territorial case studies.",
        donnees: "Climatological series, environmental observation data, socio-territorial data.",
        collaborations: "Laboratories, universities, observation bodies, local authorities.",
        resultats: "Mappings, synthesis notes and structuring research hypotheses for the future Centre."
      },
      {
        title: "Lasting energy transition",
        problematique: "Which technological solutions can contribute to a lasting energy transition?",
        questions: ["Which technologies are mature, and which remain to be proven?", "How can the relevance of a solution be assessed at the scale of a rural territory?", "Which technical and organisational barriers should be lifted first?"],
        methodologie: "Technology watch, comparative analyses, real-world feasibility studies.",
        donnees: "Energy production and consumption data, documented feedback, territorial data.",
        collaborations: "Engineering schools, consulting firms, technology companies, local authorities.",
        resultats: "Comparative studies, assessment frameworks, territorial transition scenarios."
      },
      {
        title: "From knowledge to territorial action",
        problematique: "How can scientific knowledge be turned into concrete solutions for territories?",
        questions: ["Which mechanisms turn a scientific result into a deployed solution?", "How can residents and local actors be involved in the research process?", "How can the real impact of a lasting solution be measured?"],
        methodologie: "Action research, pilot experiments, co-built impact indicators.",
        donnees: "Usage data, field surveys, environmental and social indicators.",
        collaborations: "Local authorities, public institutions, environmental organisations, universities.",
        resultats: "Transfer protocols, methodological guides, first documented experiments."
      }
    ],
    honestyNote: "These domains describe research intentions. They will evolve as the scientific network is built and as the future Scientific Board makes its decisions.",
    formOverline: "Contribute",
    formTitle: "Propose a research project",
    formText: "Are you carrying a research question related to our axes? Describe it: it will feed the preparatory work of the future research programme.",
    formSubmit: "Send the proposal"
  },
  scientifiques: {
    metaTitle: "Scientific network — Green Horizon Project",
    metaDesc: "Green Horizon Project brings together researchers, engineers, professors and technicians around the building of its future research programme.",
    overline: "Scientific Board — future constitution",
    titleLines: ["Federating", "expertise"],
    intro: "The statutes of Green Horizon Project provide for a Scientific Board bringing together researchers, inventors, professors, engineers and technicians. This board is not yet constituted: the association wishes to progressively gather around its project the scientific and technical profiles able to contribute to its future research activity.",
    profilesOverline: "Sought profiles",
    profilesTitle: "Six families of expertise",
    profiles: [
      { title: "Researchers & lecturer-researchers", text: "Climate sciences, environmental sciences, energy, data, social sciences of the transition." },
      { title: "Engineers", text: "Energy, environment, instrumentation, modelling, observation systems." },
      { title: "Professors", text: "Higher education, supervision of research work, knowledge transfer." },
      { title: "Technicians", text: "Measurement, instrumentation, equipment maintenance, field data." },
      { title: "Students & early-career researchers", text: "Internships, supervised work, first contributions to future programmes." },
      { title: "Inventors & specialists", text: "Technological innovation, prototyping, climate expertise, environment and energy professionals." }
    ],
    calloutTitle: "Are you a researcher, engineer, professor, technician or climate specialist?",
    calloutText: "Joining the network is not a recruitment for an existing laboratory: it is about identifying the people interested in building the future research programme of Green Horizon Project.",
    formTitle: "Join the scientific network",
    formSubmit: "Join the network"
  },
  partenariats: {
    metaTitle: "Scientific partnerships — Green Horizon Project",
    metaDesc: "Green Horizon Project is preparing a network of partners: universities, laboratories, companies, local authorities, foundations.",
    overline: "Scientific partnerships",
    titleLines: ["Building a network", "of partners"],
    intro: "Creating the future research Centre requires alliances. Green Horizon Project is preparing the progressive constitution of a network of scientific, technological, territorial and financial partners.",
    targetsOverline: "Sought collaborations",
    targetsTitle: "Who do we want to talk to?",
    targets: [
      "Universities", "Laboratories", "Research organisations", "Engineering schools",
      "Consulting firms", "Technology companies", "Local authorities", "Public institutions",
      "Environmental organisations", "Foundations", "Patrons"
    ],
    honestyTitle: "A note of transparency",
    honestyText: "Green Horizon Project claims no formalised institutional partnership to date. This page presents the types of collaborations sought — and nothing else.",
    formTitle: "Propose a partnership",
    formText: "Does your organisation wish to explore a collaboration? Write to us: every proposal is reviewed by the association's Board.",
    formSubmit: "Propose a partnership"
  },
  roadmap: {
    metaTitle: "Roadmap — Green Horizon Project",
    metaDesc: "The strategic roadmap of Green Horizon Project: structuring, scientific preparation, launch of the Centre, international development.",
    overline: "Roadmap",
    titleLines: ["An evolving vision,", "in five milestones"],
    intro: "This roadmap is an evolving, intentionally general vision: Green Horizon Project does not yet have a definitive scientific calendar or a settled experimental programme. It describes a trajectory, not a detailed action plan.",
    phases: [
      {
        num: "Today",
        period: "",
        title: "Structure",
        status: "progress",
        items: ["Structure the association", "Develop its presence around climate, environmental and scientific issues", "Consolidate the governance established by the 2025 general assembly"]
      },
      {
        num: "Progressively",
        period: "",
        title: "Reflect and federate",
        status: "prep",
        items: ["Develop a scientific reflection and a watch", "Build a network of skills", "Seek relevant collaborations"]
      },
      {
        num: "In time",
        period: "",
        title: "Engage the work",
        status: "vision",
        items: ["Progressively engage scientific and experimental work, once the conditions are met"]
      },
      {
        num: "Then",
        period: "",
        title: "Refine the axes",
        status: "vision",
        items: ["The work actually carried out will progressively refine the future research axes"]
      },
      {
        num: "Longer term",
        period: "",
        title: "Create the Centre",
        status: "vision",
        items: ["Envision the creation and structuring of the Global Climate Research Centre"]
      }
    ],
    note: "This trajectory announces no Centre creation date, no laboratory opening, no headcount and no quantified objectives. It is an evolving vision, not an operational calendar."
  },
  soutenir: {
    metaTitle: "Support research — Green Horizon Project",
    metaDesc: "Donations, patronage, partnerships, calls for projects: support the preparation of Green Horizon Project's future climate research Centre.",
    overline: "Support research",
    titleLines: ["Let us build the future", "research Centre together"],
    intro: "Preparing a research Centre requires means: human, scientific, material and financial. The association's statutes explicitly provide for seeking funding — donations, bequests, transfers of real estate or equipment, and any other legal means necessary to achieve its vision.",
    optionsOverline: "How to contribute",
    optionsTitle: "Eight ways to contribute",
    options: [
      { title: "Membership", text: "Join the association as a member and take part in its statutory life." },
      { title: "Donations", text: "Direct financial support for the preparatory work — via PayPal (temporary solution) or by agreement." },
      { title: "Corporate patronage", text: "Corporate commitment: financial, skills-based or in-kind." },
      { title: "Partnerships", text: "Collaborations with technology companies, consulting firms and organisations." },
      { title: "Grants & calls for projects", text: "Public schemes, national or European programmes, where the association is eligible." },
      { title: "Framework agreements", text: "Formal agreements with institutions, universities and bodies." },
      { title: "Material & technological support", text: "Equipment, instrumentation, infrastructure: the concrete matters as much as the financial." },
      { title: "Expertise & skills", text: "Provision of scientific, technical or legal expertise." }
    ],
    noAmountNote: "For the sake of transparency, no amount or fundraising target is displayed at this stage: they will be defined and published after validation by the association.",
    formTitle: "Support the project",
    formText: "Tell us how you would like to contribute: we will get back to you to build the right arrangement together.",
    formSubmit: "Support GHP",
    otherCtas: ["Become a partner", "Propose a project"]
  },
  actualites: {
    metaTitle: "News — Green Horizon Project",
    metaDesc: "The Green Horizon Project logbook: progress of the preparatory work for the future climate research Centre.",
    overline: "News",
    titleLines: ["The project", "logbook"],
    emptyTitle: "The GHP research programme is currently under construction.",
    emptyText: "We only publish real, verifiable content. The first news items — governance, scientific network, partnerships, calls for projects — will be published here as soon as they are documented.",
    themesOverline: "Coming to this logbook",
    themesTitle: "What we will talk about",
    themes: [
      "Climate and scientific research", "Energy transition", "Innovations",
      "Environment", "Calls for projects", "Conferences",
      "Preparatory work of the Centre", "Partnerships", "Events"
    ],
    sourcesOverline: "Reference sources",
    sourcesTitle: "The reliable sources we follow",
    sourcesText: "Our editorial agent cross-references these institutions' publications every month to compose the climate watch review. These are public, verifiable references.",
    sources: [
      { name: "IPCC", url: "https://www.ipcc.ch", desc: "Reference scientific assessments of climate change" },
      { name: "WMO", url: "https://wmo.int", desc: "Global weather and climate data" },
      { name: "Copernicus C3S", url: "https://climate.copernicus.eu", desc: "European climate change observation service" },
      { name: "NASA Climate", url: "https://climate.nasa.gov", desc: "Global climate indicators and satellite observation" },
      { name: "NOAA", url: "https://www.noaa.gov", desc: "Oceans, atmosphere and climate data" },
      { name: "ADEME", url: "https://www.ademe.fr", desc: "Ecological and energy transition in France" },
      { name: "Météo-France", url: "https://meteofrance.com", desc: "French climate observations and data" },
      { name: "Haut Conseil pour le Climat", url: "https://www.hautconseilclimat.fr", desc: "Independent body assessing French climate policies" }
    ],
    newsletterTitle: "Stay informed of the next steps",
    newsletterText: "Leave your address: you will receive the project's real milestones, without embellishment."
  },
  ressources: {
    metaTitle: "Publications and resources — Green Horizon Project",
    metaDesc: "The Green Horizon Project document base: statutes, minutes, reports and future scientific publications.",
    overline: "Publications & resources",
    titleLines: ["The document", "base"],
    intro: "This library will progressively host the association's official and scientific documents. Its architecture is ready; documents will be published as they are validated by the Board.",
    categories: [
      { title: "Statutes", text: "Founding statutes adopted on 31 October 2022 in Limoges." },
      { title: "Minutes", text: "Minutes of the extraordinary general assembly of 17 April 2025 and of future assemblies." },
      { title: "Activity reports", text: "Annual reviews of the association's action." },
      { title: "Financial reports", text: "Financial documents and use of resources." },
      { title: "Scientific documents", text: "Framing notes and working documents of the future programme." },
      { title: "Research notes", text: "Methodological notes and working hypotheses." },
      { title: "Project reports", text: "Reports of future studies and missions." },
      { title: "Publications", text: "Published scientific work, when it exists." },
      { title: "Press releases", text: "Official statements and announcements of the association." }
    ],
    emptyLabel: "No document published yet",
    note: "In line with our transparency principle, only real, validated documents will be published here."
  },
  transparence: {
    metaTitle: "Transparency — Green Horizon Project",
    metaDesc: "Credibility as a principle: what is achieved is documented, what is in preparation is identified, what belongs to the vision is owned as ambition.",
    overline: "Transparency",
    titleLines: ["Credibility", "as a principle"],
    intro: "Green Horizon Project is a young association, with high ambition and sober communication. This page formalises our rule: never artificially embellish our level of activity.",
    ruleTitle: "How to read this site",
    rules: [
      { label: "Achieved", text: "What has been achieved is documented — statutes, general assembly, verifiable facts." },
      { label: "In preparation", text: "What is ongoing or in preparation is identified as such, without being presented as acquired." },
      { label: "Future vision", text: "What belongs to the future — the research Centre, programmes, partnerships — is presented as an ambition, never as a reality." }
    ],
    govOverline: "Governance",
    govTitle: "What we can document today",
    govItems: [
      "Non-profit under the French law of 1 July 1901 and the decree of 16 August 1901",
      "Founding statutes adopted on 31 October 2022 in Limoges — unlimited duration",
      "Declared on 7 November 2022 — RNA W872015875 · SIREN 923 445 043 · ESS field",
      "Registered office: 99 Route de la Croisille-sur-Briance, 87130 Sussac",
      "Board reconfigured by the extraordinary general assembly of 17 April 2025 in Limoges",
      "President: Mr Cyril Mulumba Mukendi",
      "Secretary: Ms Marie-Odile Isabelle Basthier",
      "Treasury: seat vacant until further notice (decision of the assembly of 17 April 2025)",
      "Founding member outside the Board: Mr Marcel Samuel Kadima Kalonji",
      "Field activities coordinator: Ms Émilie Millet"
    ],
    pendingOverline: "Being validated",
    pendingTitle: "To be validated by Green Horizon Project",
    pendingText: "The following elements are being validated by the association and will be published once confirmed:",
    pending: [
      "Official social media accounts"
    ]
  },
  contact: {
    metaTitle: "Contact — Green Horizon Project",
    metaDesc: "Contact the Green Horizon Project association, based in Sussac (Haute-Vienne). Replies in French or English.",
    overline: "Contact",
    titleLines: ["Write to us"],
    intro: "A question, a proposal, a wish to contribute? This form is the association's official point of entry.",
    infoTitle: "The association",
    infoItems: [
      { label: "Status", value: "Non-profit under the French law of 1 July 1901" },
      { label: "Registered office", value: "99 Route de la Croisille-sur-Briance — 87130 Sussac, France" },
      { label: "Email", value: "contact@greenhorizonproject.org" },
      { label: "Statutory foundation", value: "31 October 2022, Limoges" },
      { label: "Languages", value: "Français · English" }
    ],
    emailNote: "Prefer to write directly? Our official address is shown above. This form remains the preferred channel for a quick reply.",
    formTitle: "General contact",
    formSubmit: "Send the message"
  },
  legal: {
    mentionsTitle: "Legal notice",
    mentionsMeta: "Legal notice of the Green Horizon Project association website.",
    mentionsSections: [
      { title: "Publisher", text: "Green Horizon Project (GHP), non-profit organisation under the French law of 1 July 1901. Statutes adopted on 31 October 2022 in Limoges. Registered office: 99 Route de la Croisille-sur-Briance, 87130 Sussac, France." },
      { title: "Registration", text: "Declared association, registered on 7 November 2022 under RNA number W872015875. SIREN: 923 445 043 — SIRET: 923 445 043 00014. APE code: 94.99Z (other membership organisations). The association belongs to the social and solidarity economy (ESS) field." },
      { title: "Publication director", text: "The President of the association, Mr Cyril Mulumba Mukendi." },
      { title: "Contact", text: "Via the website contact form or by email: contact@greenhorizonproject.org." },
      { title: "Hosting", text: "Website hosted on Emergent infrastructure." },
      { title: "Intellectual property", text: "All content on this site (texts, graphic elements) is the property of the Green Horizon Project association, unless otherwise stated. Any reproduction without authorisation is prohibited." },
      { title: "Information being validated", text: "Official social media accounts: these details will be completed once they are created." }
    ],
    privacyTitle: "Privacy policy",
    privacyMeta: "Privacy and personal data protection policy of Green Horizon Project (GDPR).",
    privacySections: [
      { title: "Data controller", text: "Green Horizon Project (GHP), non-profit under the French law of 1 July 1901, registered office: Sussac, Haute-Vienne, France." },
      { title: "Data collected", text: "Through our forms (scientific network, partnership, support, project proposal, contact) and the newsletter subscription: name, email address, organisation, message content. No other personal data is collected." },
      { title: "Purposes and legal basis", text: "Data is used exclusively to respond to your request and, where relevant, to inform you of the project's milestones. Legal basis: your consent, collected through a mandatory checkbox." },
      { title: "Retention period", text: "Data is kept for the time needed to process your request, then archived for a maximum of three years, unless you request its deletion." },
      { title: "Processors", text: "Website hosting and transactional email service. Your data is neither sold nor shared with third parties for commercial purposes." },
      { title: "Your rights", text: "Under the GDPR, you have rights of access, rectification, erasure, restriction and objection. Exercise them via the contact form. You may also contact the CNIL." },
      { title: "Cookies", text: "This site does not currently set any tracking or analytics cookies." }
    ]
  },
  newsCats: {
    centre: "Centre works",
    climat: "Climate",
    transition: "Energy transition",
    innovation: "Innovation",
    environnement: "Environment",
    appels: "Calls for projects",
    conferences: "Conferences",
    partenariats: "Partnerships",
    evenements: "Events",
    vie: "Association life",
    veille: "Climate watch"
  },
  adminTypes: {
    network: "Scientific network",
    partner: "Partnership",
    support: "Support",
    project: "Research project",
    contact: "General contact"
  },
  admin: {
    loginTitle: "Administration area",
    loginSub: "Restricted to the association's Board",
    email: "Email address",
    password: "Password",
    login: "Sign in",
    loggingIn: "Signing in…",
    loginError: "Incorrect credentials or temporarily locked account.",
    backToSite: "Back to site",
    logout: "Sign out",
    dashboard: "Dashboard",
    tabSubmissions: "Received requests",
    tabNews: "News",
    tabDocs: "Documents",
    all: "All",
    delete: "Delete",
    confirmDelete: "Confirm deletion?",
    deleted: "Item deleted.",
    empty: "No items yet.",
    submissionsEmpty: "No requests received yet.",
    newsNew: "Publish a news item",
    titleFr: "Title (FR) *",
    titleEn: "Title (EN)",
    summaryFr: "Summary (FR)",
    summaryEn: "Summary (EN)",
    contentFr: "Content (FR) *",
    contentEn: "Content (EN)",
    category: "Category",
    publish: "Publish",
    newsSaved: "News item published.",
    docNew: "Add a document",
    file: "File (PDF preferred) *",
    descFr: "Description (FR)",
    descEn: "Description (EN)",
    upload: "Add document",
    docSaved: "Document added.",
    download: "Download",
    receivedOn: "Received on",
    agentBtn: "Generate a climate watch review (AI)",
    agentStarted: "Generation started — the article will appear here within 1 to 2 minutes.",
    agentGenerating: "Generating…",
    newsEdit: "Edit news item",
    update: "Update",
    cancel: "Cancel",
    newsUpdated: "News item updated.",
    tabDashboard: "Dashboard",
    tabEvents: "Events",
    tabProjects: "Projects",
    tabNewsletter: "Newsletter",
    eventNew: "Create an event",
    eventEdit: "Edit event",
    eventSaved: "Event created.",
    eventUpdated: "Event updated.",
    date: "Date and time",
    endDate: "End (optional)",
    location: "Location",
    type: "Type",
    link: "Link (optional)",
    projectNew: "Create a project",
    projectEdit: "Edit project",
    projectSaved: "Project created.",
    projectUpdated: "Project updated.",
    status: "Status",
    subscribers: "Watch letter subscribers",
    subscribedOn: "Subscribed on",
    statsContacts: "Requests received",
    statsNetwork: "Scientific network",
    statsPartners: "Partnerships",
    statsNewsletter: "Newsletter subscribers",
    statsNews: "Published articles",
    statsDocs: "Documents",
    recentSubmissions: "Latest requests",
    upcomingEvents: "Upcoming events",
    latestNews: "Latest articles",
    nothingHere: "Nothing to display yet."
  },
  newsAgent: {
    title: "Editorial agent — monthly climate watch",
    desc: "An editorial agent automatically cross-references, once a month, available public information: natural disasters, IPCC reports and climate bodies (WMO, Copernicus…), civil society announcements, researchers' publications and scientific advances in the fight against global warming. Each article is published with an \"automated watch\" badge, emailed to the Board, and can be deleted at any time.",
    badge: "Automated watch — public sources"
  },
  paypal: {
    title: "Donate via PayPal",
    text: "Until the association's dedicated bank account is opened, donations are temporarily received on the President's PayPal account (cyrilone2002@hotmail.com). No amount is imposed: you choose freely on the secure PayPal page.",
    cta: "Donate via PayPal",
    note: "Temporary solution decided by the Board — a dedicated association account will be opened and announced here."
  },
  ressourcesKeys: ["statuts", "pv", "activite", "financiers", "scientifiques", "notes", "projets", "publications", "communiques"],
  navX: {
    presentation: "Presentation",
    evenements: "Events",
    projets: "Projects in preparation"
  },
  presentation: {
    metaTitle: "The association — Green Horizon Project",
    metaDesc: "Green Horizon Project: a declared French non-profit (RNA W872015875), based in Sussac, Haute-Vienne, dedicated to climate, the environment and the energy transition.",
    overline: "The association",
    titleLines: ["Green Horizon", "Project"],
    intro: "A real, declared and documented French non-profit, progressively preparing the scientific, human, technical, institutional and financial foundations of a future Global Climate Research Centre.",
    identityOverline: "Identity",
    identityTitle: "A declared, compliant and documented association",
    identity: [
      { label: "Legal form", value: "Non-profit under the law of 1 July 1901 — declared, ESS field" },
      { label: "RNA", value: "W872015875" },
      { label: "SIREN / SIRET", value: "923 445 043 / 923 445 043 00014" },
      { label: "Registered office", value: "99 Route de la Croisille-sur-Briance, 87130 Sussac, France" },
      { label: "Statutory foundation", value: "31 October 2022, Limoges" },
      { label: "Declaration", value: "7 November 2022" },
      { label: "Duration", value: "Unlimited" },
      { label: "APE code", value: "94.99Z — other membership organisations" }
    ],
    objetOverline: "Statutory purpose",
    objetTitle: "What the statutes provide for",
    objetIntro: "Adopted on 31 October 2022 in Limoges, the statutes define the association's purpose and orientations:",
    objet: [
      "Fight the effects of climate change",
      "Promote and protect the environment",
      "Support the energy transition",
      "Research and produce knowledge",
      "Seek partnerships",
      "Involve competent people in specific work",
      "Conduct field missions",
      "Seek the necessary funding and means",
      "Research lasting solutions for the global climate",
      "Seek the means to establish a Global Climate Research Centre"
    ],
    govOverline: "Governance",
    govTitle: "The Board, according to the minutes of 17 April 2025",
    govNote: "Composition from the latest available internal document: the extraordinary general assembly of 17 April 2025 in Limoges. No subsequent change is documented to date.",
    gov: [
      { role: "President", name: "Mr Cyril Mulumba Mukendi" },
      { role: "Secretary", name: "Ms Marie-Odile Isabelle Basthier" },
      { role: "Treasury", name: "Seat vacant until further notice" },
      { role: "Founding member outside the Board", name: "Mr Marcel Samuel Kadima Kalonji" },
      { role: "Field activities coordinator", name: "Ms Émilie Millet" }
    ],
    fonctionnementOverline: "How it works",
    fonctionnementTitle: "How the association operates",
    fonctionnement: [
      "The general assembly is the association's sovereign body.",
      "The Board, elected by the general assembly, leads the association's action.",
      "The statutes provide for a Scientific Board bringing together researchers, inventors, professors, engineers and technicians — currently being constituted.",
      "The statutes allow for the appointment of honorary members."
    ],
    docsCta: "View official documents",
    contactCta: "Contact the association"
  },
  events: {
    metaTitle: "Events — Green Horizon Project",
    metaDesc: "General assemblies, conferences, workshops and scientific meetings of Green Horizon Project.",
    overline: "Events",
    titleLines: ["Meetings and", "gatherings"],
    intro: "General assemblies, scientific meetings, conferences, workshops and working sessions: only real or officially announced events are published here.",
    upcoming: "Upcoming",
    past: "Past events",
    emptyTitle: "No events announced yet.",
    emptyText: "Upcoming general assemblies, conferences and meetings will be announced here as soon as they are made official.",
    typesTitle: "What we will organise",
    types: ["General assemblies", "Scientific meetings", "Conferences", "Working sessions", "Workshops", "Partner meetings"],
    typeLabels: { ag: "General assembly", conference: "Conference", atelier: "Workshop", rencontre: "Scientific meeting", reunion: "Meeting", partenaire: "Partner meeting" },
    moreInfo: "More information"
  },
  projects: {
    metaTitle: "Projects in preparation — Green Horizon Project",
    metaDesc: "Green Horizon Project's future scientific projects: problem statements, objectives, sought partners and progress status, in full transparency.",
    overline: "Scientific projects",
    titleLines: ["Projects", "in preparation"],
    intro: "This page will progressively present Green Horizon Project's future scientific projects. Each project is documented: problem statement, context, scientific objective, progress status, sought partners, needs and next steps.",
    emptyTitle: "The first projects will be published here.",
    emptyText: "No project is published at this stage: they will be presented once validated by the Board, with their real progress status.",
    statusesTitle: "Our status system",
    statusesText: "Every project carries an explicit status. No project is presented as \"completed\" or \"ongoing\" without real information justifying it.",
    labels: { contexte: "Context", problematique: "Problem statement", objectif: "Scientific objective", partenaires: "Sought partners", besoins: "Needs", etapes: "Next steps" },
    cta: "Propose a research project"
  },
  projectStatuses: {
    idee: "Idea",
    exploration: "Under exploration",
    preparation: "In preparation",
    partenaires: "Partners sought",
    developpement: "In development",
    termine: "Completed"
  },
  researchAxes: {
    overline: "Scientific vision",
    title: "Three axes, one ambition",
    note: "These three axes form Green Horizon Project's scientific vision — they do not represent results already achieved.",
    items: [
      { num: "01", title: "Understand the climate", text: "Developing and gathering the knowledge needed to better understand climate transformations." },
      { num: "02", title: "Anticipate transformations", text: "Studying possible trajectories and their consequences to better inform future decisions." },
      { num: "03", title: "Research lasting solutions", text: "Fostering the transformation of knowledge into concrete, lasting solutions." }
    ]
  },
  veille: {
    overline: "Scientific watch",
    title: "Building a scientific culture before the Centre",
    text: "Even before the Centre is created, Green Horizon Project is building a shared scientific culture: a monthly watch cross-references publications from reference institutions. Each piece of content clearly distinguishes the external source, the analysis or synthesis, and GHP's position or project. The watch review is emailed monthly to subscribers.",
    themes: ["Climate", "Climate change", "Adaptation", "Energy transition", "Renewable energy", "Biodiversity", "Water", "Agriculture and climate", "Territorial resilience", "Low-carbon technologies", "Energy storage", "Environmental observation"],
    cta: "Read the watch review"
  },
  researchNav: {
    overline: "Explore",
    title: "The scientific sections",
    items: [
      { label: "Research programme", to: "/programme" },
      { label: "Projects in preparation", to: "/projets" },
      { label: "Scientific watch", to: "/actualites" },
      { label: "Scientific network", to: "/scientifiques" },
      { label: "The future Centre", to: "/centre" }
    ]
  },
  centreSteps: {
    overline: "Prospective roadmap",
    title: "Five steps to build the Centre",
    note: "These steps are not completed: they describe the envisioned process for progressively building the future Centre.",
    steps: [
      { num: "01", title: "Prepare", items: ["Scientific watch", "Identifying major climate challenges", "Documentation", "Structuring the first research axes"] },
      { num: "02", title: "Federate", items: ["Researchers and scientists", "Engineers and experts", "Universities and institutions", "Companies and environmental organisations"] },
      { num: "03", title: "Develop", items: ["Research projects", "Studies and field observations", "Collaborations", "Pilot projects"] },
      { num: "04", title: "Fund", items: ["Grants", "Patronage and partnerships", "Calls for projects", "Public and private funding"] },
      { num: "05", title: "Create", items: ["Progressive construction of the future Centre, physical and institutional"] }
    ]
  },
  threeStates: {
    overline: "A clear reading",
    title: "What exists, what is in preparation, what remains to be built",
    cols: [
      { label: "Already established", items: ["Declared non-profit under the 1901 law (RNA W872015875)", "Statutes adopted on 31 October 2022 in Limoges", "Climate and environmental purpose", "The future Centre's ambition written into the statutes", "Board reconfigured on 17 April 2025"] },
      { label: "In preparation", items: ["Scientific and digital presence", "Monthly scientific watch", "Scientific network", "Identification of research axes", "Search for partners", "Preparation of future projects"] },
      { label: "To be built", items: ["Structured research programmes", "Scientific infrastructures", "A physical research Centre", "Permanent scientific teams", "Institutional partnerships"] }
    ]
  },
  notFound: {
    title: "Page not found",
    text: "The page you are looking for does not exist or has been moved.",
    cta: "Back to homepage"
  }
};
